var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSpeedHyperTurbo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 5.545c0-.756.99-1.037 1.388-.395l3.993 6.455a.75.75 0 010 .79l-3.993 6.454c-.398.643-1.388.361-1.388-.394V5.545zM9.375 5.545c0-.756.99-1.037 1.388-.395l3.993 6.455a.75.75 0 010 .79l-3.993 6.454c-.398.643-1.388.361-1.388-.394V5.545zM15.375 5.545c0-.756.99-1.037 1.388-.395l3.993 6.455a.75.75 0 010 .79l-3.993 6.454c-.398.643-1.388.361-1.388-.394V5.545z",
    fill: "currentColor"
  })));
}
SvgPokerSpeedHyperTurbo.displayName = 'PokerSpeedHyperTurbo';
export default SvgPokerSpeedHyperTurbo;